/* eslint-disable import/no-unresolved */
import { Grid, Box, Button, CircularProgress } from '@mui/material';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { validationSchema } from '@/utils/helpers';
import {
  useCreateCustomer,
  useFetchCustomerGroups,
  useFetchCustomers,
} from '@/services/hooks';
import Input from '@/components/Forms/Input';
import Select from '@/components/Forms/Select';
import { useDispatch } from 'react-redux';
import { setAlert } from '@/store/slices/alert';

const CreateCustomerForm = () => {
  const dispatch = useDispatch();

  const { data: customers } = useFetchCustomers('', '');

  const customerPhones: string[] = customers
    ?.map((customer: { phone: string | null | undefined }) => customer?.phone)
    .filter((phone: string) => phone !== null && phone !== undefined);

  const customerEmails: string[] = customers
    ?.map((customer: { email: string | null | undefined }) => customer?.email)
    .filter((email: string) => email !== null && email !== undefined);

  const customerNames: string[] = customers
    ?.map(
      (customer: { customer_name: string | null | undefined }) =>
        customer?.customer_name,
    )
    .filter(
      (customer_name: string) =>
        customer_name !== null && customer_name !== undefined,
    );

  const initialState = {
    fullName: '',
    phoneNumber: '',
    email: '',
    customerGroup: '',
    homeAddress: '',
  };

  const { mutate, isLoading } = useCreateCustomer();
  const { data: customerGroups } = useFetchCustomerGroups();

  const { dynamic, phoneNumber, optional, email } = validationSchema;

  const handleSubmit = (values: typeof initialState) => {
    const customerObj = {
      customer_name: values.fullName,
      mobile_no: values.phoneNumber,
      customer_group:
        values.customerGroup === ''
          ? 'All Customer Groups'
          : values.customerGroup,
      primary_address: values.homeAddress === '' ? null : values.homeAddress,
      territory: 'All Territories',
    };
    if (customerPhones?.includes(values?.phoneNumber)) {
      dispatch(
        setAlert({
          type: 'error',
          message: `Customer with phone number ${values?.phoneNumber} already exists`,
        }),
      );
    } else if (customerEmails?.includes(values?.email)) {
      dispatch(
        setAlert({
          type: 'error',
          message: `Customer with email ${values?.email} already exists`,
        }),
      );
    } else if (customerNames?.includes(values?.fullName)) {
      dispatch(
        setAlert({
          type: 'error',
          message: `Customer with email ${values?.fullName} already exists`,
        }),
      );
    } else {
      mutate(customerObj);
    }
  };

  return (
    <Box mt={6}>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        validationSchema={yup.object({
          fullName: dynamic('Customer full name '),
          phoneNumber,
          email,
          customerGroup: optional(),
          homeAddress: optional(),
        })}
      >
        <Form>
          <Grid container columnSpacing={4} rowSpacing={6}>
            <Input
              name="fullName"
              type="text"
              label="Customer full name"
              size={6}
            />
            <Input
              name="phoneNumber"
              type="text"
              label="Customer Phone number"
              size={6}
            />
            <Input
              name="email"
              type="text"
              label="Enter email address"
              size={12}
            />
            <Select
              name="customerGroup"
              label="Select Customer group"
              item={customerGroups}
            />
            <Input
              name="homeAddress"
              type="text"
              label="Enter home address"
              size={12}
            />

            <Grid item xs={9} marginTop={10} sx={{ mx: 'auto' }}>
              {isLoading ? (
                <CircularProgress />
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ borderRadius: 2 }}
                >
                  Save Customer
                </Button>
              )}
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default CreateCustomerForm;
